// Абсолютная база для API-запросов. В вебе origin страницы и есть сервер —
// относительный путь работает (VITE_APP_ORIGIN там совпадает с origin). В
// упакованном Tauri origin приложения (tauri://localhost на macOS,
// http://tauri.localhost на Windows) на сервер НЕ указывает — относительные
// /api/... уходят в asset-протокол и молча 404-ят, нужен абсолютный адрес из
// VITE_APP_ORIGIN (зашивается при сборке). В dev переменная пуста — остаётся
// относительный путь через vite-прокси.
export function apiUrl(path: string): string {
    if (/^https?:\/\//.test(path)) {
        return path;
    }
    const base = (import.meta.env.VITE_APP_ORIGIN as string | undefined) ?? "";
    return `${base}${path}`;
}
